/* Restored from kk-lead-time-builder (final_v2).
   Previously pasted inline in theme.liquid; now loaded as an asset.

   >>> YOUR SAVED RULES GO IN G_IS / G_OV / P_NONE BELOW. <<<
   Open kk-lead-time-builder_final_v2.html in the same browser you built it in
   (your saved rules load automatically), open the "OPTIS JS Code" tab, and copy
   the contents of the G_IS, G_OV, and P_NONE blocks (and DEFAULT/IDX if you
   changed them) over the ones below.                                          */
(function(){

  /* === K+K Lead Time Logic (Variant-Aware) ===
     This script combines two sources of truth:
       1) Base product status (from variant metafields, via #kkLeadVariantData JSON)
       2) Option-driven rules (matched against BSS_PO option text)
     Whichever lead time is LONGER wins. */

  var DEFAULT="4-6 weeks";
  var IDX=0;

  /* Global in-stock keywords → green box (if base also in stock) */
  var G_IS=[
    /* PASTE YOUR SAVED IN-STOCK KEYWORDS HERE, e.g.
    'No Bracket',
    'Standard Mount'
    */
  ];

  /* Global lead time overrides → amber with specific time */
  var G_OV=[
    /* PASTE YOUR SAVED OVERRIDES HERE, e.g.
    ['Custom Color','6-8 weeks'],
    ['Chrome Housing','3-5 weeks']
    */
  ];

  /* Product-specific None rules
     Key = product handle (from URL), Value = "instock" | "default" | lead time string */
  var P_NONE={
    /* PASTE YOUR SAVED NONE-RULES HERE, e.g.
    'federal-signal-micropulse-ultra-mps6u':'instock'
    */
  };

  var last="";
  var baselineText=null;
  var interactionSeen=false;

  function getHandle(){
    var m=window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m?m[1]:"";
  }

  /* Parse the upper bound of a lead time string in weeks.
     "4-6 weeks" → 6, "2 weeks" → 2, "Ships within 1-2 business days" → 0 */
  function parseMaxWeeks(text){
    if(!text)return 0;
    if(/business days|in stock|ready to ship|ships within/i.test(text))return 0;
    var m=text.match(/(\d+)\s*[-\u2013to]+\s*(\d+)\s*weeks?/i);
    if(m)return parseInt(m[2],10);
    m=text.match(/(\d+)\s*weeks?/i);
    if(m)return parseInt(m[1],10);
    return 0;
  }

  /* Read base variant status from the JSON block placed by the snippet. */
  function getBaseStatus(){
    try{
      var el=document.getElementById("kkLeadVariantData");
      if(!el)return null;
      var data=JSON.parse(el.textContent);
      var vid=new URLSearchParams(location.search).get("variant");
      if(!vid){
        var inp=document.querySelector('form[action*="/cart/add"] [name="id"]');
        if(inp&&inp.value)vid=inp.value;
      }
      if(!vid||!data[vid])return null;
      return data[vid];
    }catch(e){return null;}
  }

  function setGreen(){
    var n=document.getElementById("kkLeadNotice");
    var h=document.getElementById("kkLeadHeader");
    var l=document.getElementById("kkLeadLabel");
    var t=document.getElementById("kkLeadText");
    var s=document.getElementById("kkLeadSub");
    var b=document.getElementById("kkLeadBody");
    if(!n)return;
    n.style.background="#F0FAF4";n.style.borderColor="#2d8a2d";
    if(h)h.style.color="#1a5c1a";
    if(l){l.textContent="In Stock ";l.style.color="#1a5c1a";}
    if(t){t.textContent="Ships within 1\u20132 business days";t.style.color="#1a5c1a";}
    if(s){s.style.display="none";s.textContent="";}
    if(b){b.textContent="You will receive a tracking confirmation once your order ships.";b.style.color="#2d5a2d";}
    var blk=document.querySelector(".kk-lead-block");if(blk)blk.style.opacity="1";
  }

  function setAmber(text){
    var n=document.getElementById("kkLeadNotice");
    var h=document.getElementById("kkLeadHeader");
    var l=document.getElementById("kkLeadLabel");
    var t=document.getElementById("kkLeadText");
    var s=document.getElementById("kkLeadSub");
    var b=document.getElementById("kkLeadBody");
    if(!n)return;
    n.style.background="#FFF8F0";n.style.borderColor="#000000";
    if(h)h.style.color="#000000";
    if(l){l.textContent="Estimated Lead Time";l.style.color="#000000";}
    if(t){t.textContent=text;t.style.color="#000000";}
    if(s){s.style.display="";s.textContent=" from order date";s.style.color="#000000";s.style.fontSize="13px";s.style.fontWeight="400";}
    if(b){b.textContent="You'll receive a shipping confirmation with tracking once your order ships.";b.style.color="#000000";}
    var blk=document.querySelector(".kk-lead-block");if(blk)blk.style.opacity="1";
  }

  /* Determine what the OPTION alone wants the display to be.
     Returns {kind:"in_stock"} or {kind:"lead", text:"4-6 weeks"} or {kind:"default"} or {kind:"base"} */
  function getOptionIntent(text){
    /* 1) "None" selected — check product-specific rule */
    if(text==="None"||text.indexOf("None")!==-1){
      var rule=P_NONE[getHandle()];
      if(rule==="instock")return {kind:"in_stock"};
      if(rule&&rule!=="default")return {kind:"lead",text:rule};
      if(rule==="default")return {kind:"default"};
      /* No product-None rule — "None" means just the base product, use base lead time. */
      return {kind:"base"};
    }
    /* 2) Global in-stock keyword match */
    for(var i=0;i<G_IS.length;i++){
      if(text.indexOf(G_IS[i])!==-1)return {kind:"in_stock"};
    }
    /* 3) Global lead time override match */
    for(var j=0;j<G_OV.length;j++){
      if(text.indexOf(G_OV[j][0])!==-1)return {kind:"lead",text:G_OV[j][1]};
    }
    /* 4) Default */
    return {kind:"default"};
  }

  function combineAndRender(opt,base){
    /* "base" intent — None selected without a product rule.
       Show whatever the base variant says, no option contribution. */
    if(opt.kind==="base"){
      if(!base){setAmber("Varies based on options selected");return;}
      if(base.in_stock){setGreen();return;}
      if(base.lead_min!=null&&base.lead_max!=null){
        setAmber(base.lead_min+"\u2013"+base.lead_max+" weeks");
      }else{
        setAmber("Varies based on options selected");
      }
      return;
    }
    /* Convert each side to a max-week number for comparison. */
    var optWeeks=opt.kind==="in_stock"?0:
                 opt.kind==="lead"?parseMaxWeeks(opt.text):
                 parseMaxWeeks(DEFAULT);
    var baseWeeks=!base?0:(base.in_stock?0:(base.lead_max||0));
    var baseInStock=!base?true:!!base.in_stock;

    /* Whichever takes LONGER wins. */
    if(baseWeeks>optWeeks){
      /* Base product is the bottleneck. */
      if(baseInStock){setGreen();}
      else{
        if(base.lead_min!=null&&base.lead_max!=null)
          setAmber(base.lead_min+"\u2013"+base.lead_max+" weeks");
        else setAmber(DEFAULT);
      }
    }else{
      /* Option is the bottleneck (or tied — option text is more specific). */
      if(opt.kind==="in_stock")setGreen();
      else if(opt.kind==="lead")setAmber(opt.text);
      else setAmber(DEFAULT);
    }
  }

  function pageHasOptisOptions(){
    /* BSS_PO.appliedOptionSet is set per-product by BSS itself.
       Truthy object/array = this product has Optis options applied.
       Undefined/null/empty = this product has no Optis options. */
    if(typeof BSS_PO==="undefined")return false;
    try{
      var aos=BSS_PO.appliedOptionSet;
      if(!aos)return false;
      if(Array.isArray(aos))return aos.length>0;
      if(typeof aos==="object"){for(var k in aos)return true;return false;}
      return true;
    }catch(e){return false;}
  }

  function runOnce(){
    try{
      /* Detect whether this page has Optis options at all.
         Even if BSS_PO is loading or empty, the DOM scan catches the Brackets dropdown etc. */
      var bssReady=(typeof BSS_PO!=="undefined"&&BSS_PO.currentSelectedOptions);
      var vals=bssReady?BSS_PO.currentSelectedOptions.allValues:null;
      var hasOptions=(vals&&vals.length>0)||pageHasOptisOptions();
      if(!hasOptions)return;
      var text=(vals&&vals.length&&vals[IDX]&&vals[IDX].value)||"";

      /* Track interaction: baseline = whatever was selected on first encounter.
         Once text differs from baseline, customer has interacted. */
      if(baselineText===null)baselineText=text;
      else if(text!==baselineText)interactionSeen=true;

      /* Re-run when either the option OR the variant changes. */
      var vid=new URLSearchParams(location.search).get("variant")||"";
      if(!vid){
        var inp=document.querySelector('form[action*="/cart/add"] [name="id"]');
        if(inp)vid=inp.value||"";
      }
      var sig=text+"|"+vid+"|"+(interactionSeen?"1":"0");
      if(sig===last)return;
      last=sig;

      if(!interactionSeen){
        /* Customer has not actively chosen yet — show "Varies..." regardless of default. */
        setAmber("Varies based on options selected");
        return;
      }

      if(!text){
        /* Options exist on this product but nothing selected — show "Varies..." */
        setAmber("Varies based on options selected");
        return;
      }

      var opt=getOptionIntent(text);
      var base=getBaseStatus();
      combineAndRender(opt,base);
    }catch(e){}
  }

  /* Immediate first check (retry briefly while BSS_PO loads) */
  (function tryInitial(left){
    if(typeof BSS_PO==="undefined"&&left>0){
      setTimeout(function(){tryInitial(left-1);},10);
      return;
    }
    runOnce();
  })(50);

  /* Ongoing polling for option/variant changes */
  setInterval(runOnce,300);

})();
